/* eslint-disable no-restricted-globals */
import { useEffect, useState } from "react"
import { useGlobalContext } from "./Context"
import  './SideBar.css'
import D from '../images/dashh.svg'
import H from '../images/damdari.svg'
import B from '../images/fans.svg'
import C from '../images/cow.svg'
import K from '../images/cycle.svg'
import message from '../images/messages.png'
import Sensor from '../images/sensor.svg'
import Packet from '../images/package.svg'
import Term from '../images/term.svg'
import U from '../images/userr.png'
import J from '../images/statuss.svg'
import Note from '../images/note.svg'
import { NavLink, useLocation } from "react-router-dom"
import { Settings } from "@mui/icons-material"
import { showUserExtra } from "../api/helper"



const SideBar=()=>{
    const Location=useLocation();
    const {setOpenSide,openSide,ToGG}=useGlobalContext();
    const Nav=document.querySelector('.navIcon4');
    const Side=document.querySelector('.SidebarCon');
    const ChilfrenCon=document.querySelector('.ChildrenCon');
    
    useEffect(()=>{
        if(window.innerWidth<1385){
            
        console.log(openSide)
        setOpenSide(false)
        console.log(openSide)
        if(openSide){
            Nav?.classList.add('open');
            ChilfrenCon?.classList.add('ChildrenConAdd')

            Side?.classList.add('openSide');
        }
        if(!openSide){
            Nav?.classList.remove('open');
            ChilfrenCon?.classList.remove('ChildrenConAdd')

            Side?.classList.remove('openSide');
        }
        }

    },[Location.pathname])
    
    return <>
        <div className='SidebarCon '>
            
           <div className="SideBarConAllCon">
           <div className="SideBarConAll">
           {/* <NavLink to='/AllFarmsAdmin'   className={( {isActive} ) => (isActive ? 'activeSideLink SidbarItem' : 'SidbarItem')}
>
                <div className="SidebarItemInfo">
                <p className="MainPT">لیست دامداری ها</p>
                    <span>لیست دامداری ها</span>
                </div>
                <div className="SidebarIcon">
                    <img className="SidebarIconimg" src={C}/>
                </div>
            </NavLink> */}
           <NavLink to='/Dashboard'   className={( {isActive} ) => (isActive ? 'activeSideLink SidbarItem' : 'SidbarItem')}
>
           
                <div className="SidebarItemInfo">
                    <p className="MainPT">داشبورد</p>
                    <span>چکیده وضعیت دامداری</span>
                </div>
                <div className="SidebarIcon">
                    <img className="SidebarIconimg" src={D}/>
                </div>
            
           </NavLink>
            
           <NavLink to='/FarmInfo'   className={( {isActive} ) => (isActive ? 'activeSideLink SidbarItem' : 'SidbarItem')}
>
                <div className="SidebarItemInfo">
                <p className="MainPT">دامداری</p>
                    <span>مشخصات دامداری  </span>
                </div>
                <div className="SidebarIcon">
                    <img className="SidebarIconimg" src={H}/>
                </div>
            </NavLink>
            

            <NavLink to='/AllAnimalls'   className={( {isActive} ) => (isActive ? 'activeSideLink SidbarItem' : 'SidbarItem')}
>
                <div className="SidebarItemInfo">
                <p className="MainPT">بهاربند</p>
                    <span> وضعیت دام های بهاربند</span>
                </div>
                <div className="SidebarIcon">
                    <img className="SidebarIconimg" src={B}/>
                </div>
            </NavLink>
            

            <NavLink to='/ListDam'   className={( {isActive} ) => (isActive ? 'activeSideLink SidbarItem' : 'SidbarItem')}
>
                <div className="SidebarItemInfo">
                <p className="MainPT">دام</p>
                    <span>لیست دام ها </span>
                </div>
                <div className="SidebarIcon">
                    <img className="SidebarIconimg" src={C}/>
                </div>
            </NavLink>
            <NavLink to='/Cycle'   className={( {isActive} ) => (isActive ? 'activeSideLink SidbarItem' : 'SidbarItem')}
>
                <div className="SidebarItemInfo">
                <p className="MainPT">چرخه ها</p>
                    <span> لیست چرخه ها</span>
                </div>
                <div className="SidebarIcon">
                <img style={{width:'50px',height:'50px'}} src={K} />
                </div>
            </NavLink>
            <NavLink to='/Status'   className={( {isActive} ) => (isActive ? 'activeSideLink SidbarItem' : 'SidbarItem')}
>
                <div className="SidebarItemInfo">
                <p className="MainPT">وضعیت ها</p>
                    <span> لیست وضعیت ها</span>
                </div>
                <div className="SidebarIcon">
                <img style={{width:'50px',height:'50px'}} src={J} />
                </div>
            </NavLink>

            {showUserExtra&&<NavLink to='/AllSensors'   className={( {isActive} ) => (isActive ? 'activeSideLink SidbarItem' : 'SidbarItem')}
>
                <div className="SidebarItemInfo">
                <p className="MainPT">سنسور ها</p>
                    <span>لیست سنسور ها</span>
                </div>
                <div className="SidebarIcon">
                <img src={Sensor} />
                </div>
            </NavLink>}
            {showUserExtra&&<NavLink to='/Packets'   className={( {isActive} ) => (isActive ? 'activeSideLink SidbarItem' : 'SidbarItem')}
>
                <div className="SidebarItemInfo">
                <p className="MainPT">کالکتور ها</p>
                    <span>لیست کالکتور ها</span>
                </div>
                <div className="SidebarIcon">
                <img src={Packet} style={{width:'50px',height:'50px'}}/>
                </div>
            </NavLink>}
            {showUserExtra&&<NavLink to='/Terminals'   className={( {isActive} ) => (isActive ? 'activeSideLink SidbarItem' : 'SidbarItem')}
>
                <div className="SidebarItemInfo">
                <p className="MainPT">ترمینال ها</p>
                    <span>لیست ترمینال ها</span>
                </div>
                <div className="SidebarIcon">
                <img src={Term} style={{width:'50px',height:'50px'}}/>
                </div>
            </NavLink>}
            <NavLink to='/Tickets'   className={( {isActive} ) => (isActive ? 'activeSideLink SidbarItem' : 'SidbarItem')}
>
                <div className="SidebarItemInfo">
                <p className="MainPT">تیکت</p>
                    <span>لیست تیکت ها</span>
                </div>
                <div className="SidebarIcon">
                <img src={message} />
                </div>
            </NavLink>
            <NavLink to='/Comments'   className={( {isActive} ) => (isActive ? 'activeSideLink SidbarItem' : 'SidbarItem')}
>
                <div className="SidebarItemInfo">
                <p className="MainPT">یادداشت ها</p>
                    <span>لیست یادداشت ها</span>
                </div>
                <div className="SidebarIcon">
                <img width={50} height={50} src={Note} />
                </div>
            </NavLink>
            {showUserExtra&&<NavLink to='/Settings'   className={( {isActive} ) => (isActive ? 'activeSideLink SidbarItem' : 'SidbarItem')}
>
                <div className="SidebarItemInfo">
                <p className="MainPT">کاربران</p>
                    <span> لیست کاربران</span>
                </div>
                <div className="SidebarIcon">
                <img style={{width:'50px',height:'50px'}} src={U} />
                </div>
            </NavLink>}
           </div>
           </div>
           {/* <div className="toggleSideBtn">
           <div className='navIcon4' onClick={ToGG}>
  <span></span>
  <span></span>
  <span></span>
</div>
           </div> */}

        </div>
    </>
}
export default SideBar